export type TopicType = 'bid' | 'transport' | 'free' | 'my';

export enum ActionType {
	Unsubscribe = 'unsubscribe',
	Subscribe = 'subscribe',
}

export enum TrackerType {
	EM = 'EM',
	MB = 'MB',
}

export interface TransportMessage {
	longitude: number;
	latitude: number;

	transport: string;
	bid?: string;

	tracker_type: TrackerType;
	status: 'busy' | 'free';
	timestamp: number;
}

export type ErrorMessage = {
	reason: string | null;
	code: number;
};

export type RealtimeAction = {
	action: ActionType;
	topic: TopicType;
};

export type RealtimeMessage = {
	data?: TransportMessage;
	notification?: string;
	error?: ErrorMessage;
	status?: string;
	topics?: string[];
};
